import { jsx as r } from "react/jsx-runtime";

import { forwardRef as o, useReducer as i } from "react";

import e from "@ui-components-3/icons/lib/regular/EyeSlash";

import t from "@ui-components-3/icons/lib/regular/Eye";

import s from "../../hooks/useId/index.js";

import a from "../Input/index.js";

const n = r => !r, l = o((({id: o, disabled: l, VisibilityTogglerProps: d, ...m}, p) => {
    const u = s(o), [c, b] = i(n, !1);
    return r(a, {
        ...m,
        multiline: !1,
        ref: p,
        type: c ? "text" : "password",
        id: u,
        disabled: l,
        suffix: r("button", {
            ...d,
            className: "btn-neutral-borderless",
            type: "button",
            disabled: l,
            onClick: b,
            "aria-controls": u,
            "aria-label": c ? "Hide password" : "Show password",
            children: r(c ? e : t, {
                "aria-hidden": "true"
            })
        })
    });
}));

export { l as default };
//# sourceMappingURL=index.js.map
